// Dependencies

import React, { Component } from "react"

// Components

import Button from "../Button/Button"

//Images

import calendar from "../images/calendar.svg"

// Style

import "./Cta.css"

const Cta = props => (
  <div className="cta">
    <div className="cta__header-container">
      <div className="cta__bg" />
      <div className="cta__header">
        <img alt="Cta" className="cta__icon" src={calendar} />
        <h1>Ready for a Hibachi party?</h1>
        <p>Schedule now for the best private 
          Hibachi experience.</p>
        {props.content}
        <Button text="Schedule Party" link="form" />
      </div>
    </div>
  </div>
)

export default Cta



// WEBPACK FOOTER //
// ./src/Cta/Cta.js